import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-auto card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "table",
  style: {"width":"auto !important"}
}
const _hoisted_5 = { class: "col-auto card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "col-auto card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "table table-sm table-hover"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-header row" }, "Aggregators", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "thead" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Site"),
              _createElementVNode("th", { scope: "col" }, "Aggregator"),
              _createElementVNode("th", { scope: "col" }, "Status")
            ])
          ], -1)),
          (_openBlock(), _createElementBlock("tbody", { key: _ctx.refresh }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aggregators, (agg) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: agg,
                class: _normalizeClass({
                online: agg.online,
                offline: !agg.online,
              })
              }, [
                _createElementVNode("td", null, _toDisplayString(agg.Tags.Site), 1),
                _createElementVNode("td", null, _toDisplayString(agg.Tags.Aggregator), 1),
                _createElementVNode("td", null, [
                  _withDirectives(_createVNode(_component_vue_feather, {
                    type: "wifi",
                    size: "16px"
                  }, null, 512), [
                    [_vShow, agg.online]
                  ]),
                  _createTextVNode(" " + _toDisplayString(agg.Status) + " for " + _toDisplayString(_ctx.formatTimeSince(agg.Time)), 1)
                ])
              ], 2))
            }), 128))
          ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header row" }, "Incidents", -1)),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createVNode(_component_vue_feather, {
          type: "alert-triangle",
          size: "42px"
        }, null, 512), [
          [_vShow, _ctx.incidents.length > 0]
        ]),
        _createElementVNode("p", null, "There are " + _toDisplayString(_ctx.incidents.length) + " active incidents.", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header row" }, "Events", -1)),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.events.length == 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "No recent events in the logs."))
          : _createCommentVNode("", true),
        (_ctx.events.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Latest events:"))
          : _createCommentVNode("", true),
        (_ctx.events.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "thead" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Time"),
                  _createElementVNode("th", { scope: "col" }, "Origin"),
                  _createElementVNode("th", { scope: "col" }, "Summary")
                ])
              ], -1)),
              (_openBlock(), _createElementBlock("tbody", { key: _ctx.refresh }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
                  return (_openBlock(), _createElementBlock("tr", { key: event }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(event.Time)), 1),
                    _createElementVNode("td", null, _toDisplayString(event.OriginTags.Site) + " / " + _toDisplayString(event.OriginTags.Aggregator), 1),
                    _createElementVNode("td", null, _toDisplayString(event.Summary), 1)
                  ]))
                }), 128))
              ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}